import { eyeSdkService } from '../utils/eyeSdkService';
import type { ApplitoolsIntegrationData } from 'clickim/src/common/api/testimVisualTestingApi';
import type { IVisualTestingProvider, ScreenshotSettings, VisualTestingResult, VisualValidationConfig, VisualTestingBatchCleanup } from './IVisualTestingProvider';

export interface ApplitoolsConfig extends VisualValidationConfig<ApplitoolsIntegrationData> {
    applitoolsSdkConfig: any;
    applitoolsSdkLogger: any;
    shouldUseVisualGrid: boolean;
    concurrency: number;
}

export interface ApplitoolsResult extends VisualTestingResult {
    eyesResults?: any;
}

export class ApplitoolsProvider implements IVisualTestingProvider {
    private openedEye: unknown;
    private config: ApplitoolsConfig;

    constructor(config: ApplitoolsConfig) {
        this.config = config;
    }

    async initialize(driver: unknown): Promise<void> {
        const eyeManager = await eyeSdkService.getManager(
            this.config.shouldUseVisualGrid,
            this.config.concurrency,
            this.config.buildId,
            this.config.credentials
        );
        
        this.openedEye = await (eyeManager as any).openEyes({
            driver,
            config: this.config.applitoolsSdkConfig,
            logger: this.config.applitoolsSdkLogger
        });
    }

    async captureScreenshot(settings: ScreenshotSettings): Promise<void> {
        await (this.openedEye as any).check({ settings });
    }

    async finalize(): Promise<ApplitoolsResult> {
        const eyesResults = await (this.openedEye as any).close();
        return { success: true, results: eyesResults, eyesResults };
    }

    static createBatchCleanup(credentials: ApplitoolsIntegrationData): VisualTestingBatchCleanup {
        return {
            async closeBatch(executionId: string) {
                const { runKey: apiKey, url: serverUrl } = credentials;
                const { makeSDK } = require('@applitools/eyes-sdk-core') as typeof import('@applitools/eyes-sdk-core');
                const tmpSDK = makeSDK({ name: 'Testim.io', version: '4.0.0', spec: {} });
                await tmpSDK.closeBatches({ settings: { batchIds: [executionId], serverUrl, apiKey } });
            },
        };
    }
}
